/* SFCG MOQ draft-only product form quantity synchronization. Checkout validation requires separate enforcement. */
(function () {
  'use strict';
  const minimum = Number(window.SFCG_PRODUCT_MOQ || 0);
  if (!Number.isFinite(minimum) || minimum < 1) return;
  const selector = '#main-product input[name="quantity"], #quantity, #product_qty_sticky, form[action*="/cart/add"] input[name="quantity"]';
  const fields = () => Array.from(document.querySelectorAll(selector)).filter(el => el instanceof HTMLInputElement);
  const normalize = value => Math.max(minimum, Math.floor(Number(value) || 0));
  let syncing = false;
  function sync(value) {
    if (syncing) return;
    syncing = true;
    try {
      const target = String(normalize(value));
      fields().forEach(el => {
        el.setAttribute('min', String(minimum));
        if (el.value !== target) {
          el.value = target;
          el.dispatchEvent(new Event('input', { bubbles: true }));
          el.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    } finally { syncing = false; }
  }
  function initial() {
    const qty = document.querySelector('#quantity');
    const sticky = document.querySelector('#product_qty_sticky');
    const primary = qty || sticky || fields()[0];
    if (primary) sync(primary.value);
  }
  document.addEventListener('input', function (event) {
    if (syncing || !event.target.matches?.(selector)) return;
    const value = Number(event.target.value);
    if (Number.isFinite(value) && value >= minimum) sync(value);
  }, true);
  document.addEventListener('change', function (event) {
    if (!syncing && event.target.matches?.(selector)) sync(event.target.value);
  }, true);
  document.addEventListener('click', function (event) {
    const button = event.target.closest?.('button[type="submit"], input[type="submit"], button[form], button[name="add"]');
    if (button && (button.closest('form[action*="/cart/add"]') || button.form?.action?.includes('/cart/add'))) {
      const qty = document.querySelector('#quantity');
      const sticky = document.querySelector('#product_qty_sticky');
      sync((sticky && button.closest('#sticky-add-to-cart')) ? sticky.value : (qty || sticky)?.value);
    }
  }, true);
  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.action.includes('/cart/add')) return;
    const qty = document.querySelector('#quantity') || form.querySelector('input[name="quantity"]');
    sync(qty?.value);
    let input = form.querySelector('input[name="quantity"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'quantity';
      form.appendChild(input);
    }
    input.value = String(normalize(qty?.value));
  }, true);
  document.addEventListener('DOMContentLoaded', initial);
  if (document.readyState !== 'loading') initial();
  new MutationObserver(initial).observe(document.documentElement, { childList: true, subtree: true });
})();